module.exports = __webpack_public_path__ + "img/telecommunications.1b3b5160.png";